import { createContext, Dispatch } from "react"
import { initialSettingsState } from "./initial"
import { SettingsAction, SettingsState } from "./types"

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const SettingsContext = createContext<[SettingsState, Dispatch<SettingsAction>]>([initialSettingsState, () => {}])
